import { LinearProgress } from '@mui/material';
import { FC, ReactElement } from 'react';

const HeadProvider: FC<{ children: ReactElement }> = ({ children }) => {
  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" />
      <meta content="width=device-width, initial-scale=1, maximum-scale=1.0" />

      {/*  <FavIcons />*/}
      <meta name="theme-color" content={'#181B1E'} />
      <meta name="msapplication-navbutton-color" content={'#181B1E'} />
      <meta name="apple-mobile-web-app-status-bar-style" content={'#181B1E'} />
      {children}
    </>
  );
};

export default HeadProvider;
